<template>
  <div class="w-100 h-100">

    <b-container fluid>
      <b-row>
        <b-col>

          <ul class="timeline">
            <li
              v-for="form in forms"
              :item="form"
              :key="form.data.id"
              class="timeline-item pulse_wrap"
            >
              <!-- Add .success here to change icon color -->
              <div class="timeline-badge" :class="getColor(form)">
                <i class="fas" :class="getIcon(form)"></i>
              </div>
              <div
                class="timeline-panel success"
              >
                <div class="timeline-heading">
                  <h5 class="timeline-title" @click="selected(form.name, form.data)">
                    {{ form.name }}
                  </h5>
                  <div class="timeline-panel-controls">
                    <div class="timestamp">
                      <small class="" v-if="form.name == 'Missed Clinic Referral' | form.name == 'Missed Followup Period'">{{ formatDate(form.data.window_start) }} - {{ formatDate(form.data.window_end) }}</small>
                      <small class="" v-else>{{ formatDate(form.data.received_on) }}</small>
                    </div>
                  </div>
                </div>
                <div class="timeline-body">
                  <b-list-group>
                    <b-list-group-item v-if="form.data.visit_code" class="d-flex justify-content-between align-items-center">
                      Visit Code
                      <b-badge variant="info" pill>{{ form.data.visit_code }}</b-badge>
                    </b-list-group-item>
                    <b-list-group-item v-if="form.data.bloodslide_code" class="d-flex justify-content-between align-items-center">
                      Bloodslide Code
                      <b-badge variant="primary" pill>{{ form.data.bloodslide_code }}</b-badge>
                    </b-list-group-item>
                    <b-list-group-item v-if="form.data.rdt_results" class="d-flex justify-content-between align-items-center">
                      RDT Result
                      <b-badge variant="secondary" pill>{{ form.data.rdt_results }}</b-badge>
                    </b-list-group-item>
                    <b-list-group-item v-if="form.data.finalmcrresult" class="d-flex justify-content-between align-items-center">
                      Microscopy
                      <b-badge :variant="form.data.finalmcrresult == 'positive' ? 'danger': 'success'" pill>{{ form.data.finalmcrresult }}</b-badge>
                    </b-list-group-item>
                    <b-list-group-item v-if="form.data.dose_1_date" class="d-flex justify-content-between align-items-center">
                      Dose 1 Date
                      <b-badge variant="dark" pill>{{ form.data.dose_1_date }}</b-badge>
                    </b-list-group-item>
                    <b-list-group-item v-if="form.data.referred_to_clinic == 'Yes'" class="d-flex justify-content-between align-items-center">
                      Referred To Clinic
                      <b-badge variant="danger" pill>{{ form.data.referred_to_clinic_date }}</b-badge>
                    </b-list-group-item>
                  </b-list-group>
                </div>
              </div>
            </li>
          </ul>
        </b-col>
      </b-row>
    </b-container>

    <b-modal id="modal-1" size="lg" scrollable ok-only>
      <template v-slot:modal-title="">
        {{ modal_title }}
        <small class="tw-text-gray-500">{{ modal_received_on }}</small>
      </template>

      <b-table responsive stacked :items="modal_items"></b-table>
    </b-modal>
  </div>
</template>

<script>
/**
 * Search a subject id and get the forms submitted for this subject.
 * Show them in a timeline. When clicked, show the details in an inverted table in a modal.
 */

import DashboardBaseTemplate from "@/layouts/DashboardBaseTemplate.vue";

import * as moment from 'moment';

export default {
  mixins: [DashboardBaseTemplate],
  props: {
    forms: {
      type: Array,
      default: function () {
        return [];
      }
    }
  },
  data: function() {
    return {
      
      modal_title: "Details",
      modal_received_on: "",
      modal_items: null,
    };
  },
  created: function() {
    
  },
  mounted: function() {
    
  },
  methods: {
    formatDate: function(date) {
      return moment(date).format('LL');
    },
    getIcon: function(form) {
      if(form.name == 'Compound Subject Followup Form') {
        return ['fa-home'];
      } else if(form.name == 'Clinic Subject Followup Form') {
        return ['fa-clinic-medical'];
      } else if(form.name == 'Case Microscopy') {
        return ['fa-microscope'];
      } else if(form.name == 'Malaria AE Treatment Form') {
        return ['fa-user-nurse'];
      } else if(form.name == 'Case Clearance Dose' || form.name == 'Case Malaria Treatment') {
        return ['fa-pills'];
      } else if(form.name == 'Malaria Treatment Call Log Form') {
        return ['fa-phone-volume'];
      } else if(form.name == 'Missed Clinic Referral') {
        return ['fa-exclamation-triangle']
      } else if(form.name == 'Missed Followup Period') {
        return ['fa-times']
      }

      return ['fa-info'];
    },
    getColor: function(form) {
      if(form.name == 'Compound Subject Followup Form') {
        return ['primary'];
      } else if(form.name == 'Clinic Subject Followup Form') {
        return ['primary'];
      } else if(form.name == 'Case Microscopy' || form.name == 'Missed Clinic Referral') {
        return ['yellow'];
      } else if(form.name == 'Malaria AE Treatment Form') {
        return ['warning'];
      } else if(form.name == 'Case Clearance Dose' || form.name == 'Case Malaria Treatment' || form.name == 'Missed Followup Period') {
        return ['danger'];
      } else if(form.name == 'Malaria Treatment Call Log Form') {
        return ['success'];
      }
      
      return [];
    },
    selected(modal_title, item) {
      let that = this;
      that.modal_title = modal_title;
      that.modal_received_on = item.received_on;
      that.modal_items = [item];
      this.$bvModal.show("modal-1");
    }
  }
};
</script>

<style lang="scss" scoped>
#timeline-header {
  font-size: 26px;
}

.cancelled {
  text-decoration: line-through;
}

.timeline-panel.today {
  height: 5px !important;
  padding-top: 0px !important;
  padding-bottom: 0px !important;
  margin-top: 0px;
  margin-bottom: 10px;
  background: #000;
  &:before {
    visibility: hidden !important;
    display: none !important;
  }
  &:after {
    visibility: hidden !important;
    display: none !important;
  }
}

.timeline-badge.warning {
  top: -20px !important;
}

.timeline-panel.past {
  background: #eee;
  &:after {
    border-right: 14px solid #eee !important;
  }
}

.timeline-panel.main_element {
  font-weight: bolder;
  color: #ffffff !important;
  background: #0196a3;
  border-color: #0196a3 !important;
  &:after {
    border-right: 14px solid #0196a3 !important;
  }
}

.timeline-panel.selected_past {
  font-weight: bolder;
  color: #ffffff !important;
  background: #333;
  border-color: #333 !important;
  &:after {
    border-right: 14px solid #333 !important;
  }
}

.timeline {
  list-style: none;
  padding: 10px 0 10px;
  position: relative;
  width: 100%;

  &:before {
    background-color: #eee;
    bottom: 0;
    content: " ";
    left: 50px;
    margin-left: -1.5px;
    position: absolute;
    top: 0;
    width: 3px;
  }

  > li {
    margin-bottom: 10px;
    position: relative;

    &:before,
    &:after {
      content: " ";
      display: table;
    }

    &:after {
      clear: both;
    }

    > .timeline-panel {
      border-radius: 2px;
      border: 1px solid #d4d4d4;
      box-shadow: 0 1px 2px rgba(100, 100, 100, 0.2);
      margin-left: 100px;
      padding: 20px;
      position: relative;

      .timeline-heading {
        .timeline-panel-controls {
          position: absolute;
          right: 8px;
          top: 5px;

          .timestamp {
            display: inline-block;
          }

          .controls {
            display: inline-block;
            padding-right: 5px;
            border-right: 1px solid #aaa;

            a {
              color: #999;
              font-size: 11px;
              padding: 0 5px;

              &:hover {
                color: #333;
                text-decoration: none;
                cursor: pointer;
              }
            }
          }

          .controls + .timestamp {
            padding-left: 5px;
          }
        }
      }
    }

    .timeline-badge {
      background-color: #999;
      border-radius: 50%;
      color: #fff;
      font-size: 1.4em;
      height: 50px;
      left: 50px;
      line-height: 52px;
      margin-left: -25px;
      position: absolute;
      text-align: center;
      top: 16px;
      width: 50px;
      z-index: 100;
    }

    .timeline-badge + .timeline-panel {
      &:before {
        border-bottom: 15px solid transparent;
        border-left: 0 solid #ccc;
        border-right: 15px solid #ccc;
        border-top: 15px solid transparent;
        content: " ";
        display: inline-block;
        position: absolute;
        left: -15px;
        right: auto;
        top: 26px;
      }

      &:after {
        border-bottom: 14px solid transparent;
        border-left: 0 solid #fff;
        border-right: 14px solid #fff;
        border-top: 14px solid transparent;
        content: " ";
        display: inline-block;
        position: absolute;
        left: -14px;
        right: auto;
        top: 27px;
      }
    }
  }
}

.timeline-badge {
  &.primary {
    background-color: #2e6da4 !important;
  }

  &.success {
    background-color: #0196a3 !important;
  }

  &.yellow {
    background-color: #cccc00 !important;
  }

  &.warning {
    background-color: #FF5E0E !important;
  }

  &.danger {
    background-color: #d9534f !important;
  }

  &.info {
    background-color: #5bc0de !important;
  }

  &.planning {
    background-color: #00629c !important;
  }
}

.timeline-title {
  margin-top: 0;
  color: inherit;
  cursor: pointer;
}

.timeline-body {
  > p,
  > ul {
    margin-bottom: 0;
  }

  > p + p {
    margin-top: 5px;
  }
}

.copy {
  position: absolute;
  top: 5px;
  right: 5px;
  color: #aaa;
  font-size: 11px;
  > * {
    color: #444;
  }
}

/*============================
				ANIMATIONS
=============================*/
.pulse_wrap {
  // animation: pulse 1.5s ease-in-out alternate infinite;
}

@keyframes pulse {
  0% {
    opacity: 0.8;
    transform: scale(0.95);
    //margin-left: -20px;
  }

  100% {
    opacity: 1;
    transform: scale(1);
  }
}
</style>
